import React from 'react'

import { Col, Row } from '_zari/core'

import * as Formatos from './formatos'

const AsientosUtiles = ({ history }) => {
  return (
    <>
      <Row className='zari-slim-form'>
        <Col md={6}>
          <Formatos.FormatoUtilCambioDeCuenta />
        </Col>
      </Row>
    </>
  )
}

export default AsientosUtiles
